import {
  getData,
  postData,
  convertPageModel
} from './api-base.service'

export const getAlibabaCloudConfigOption = () => {
  return getData('/AlibabaCloud/GetAlibabaCloudConfigOption');
}

export const getVodUploadSetting = (fileName, courseActivationId) => {
  let data = {
    fileName,
    courseActivationId
  };
  return getData('/AlibabaCloud/GetVodUploadSetting', data);
}

export const getVodUploadSettingNonCA = (fileName, type, courseId, title) => {
  let data = {
    fileName,
    type,
    courseId,
    title
  };
  return getData('/AlibabaCloud/GetVodUploadSettingNonCA', data);
}

export const refreshUploadVideo = (videoId) => {
  let data = {
    videoId
  };
  return getData('/AlibabaCloud/RefreshUploadVideo', data);
}

export const saveAliyunVodResult = (data) => {
  let result = postData('/AlibabaCloud/SaveAliyunVodResult', data);
  return result;
}

export const getAliyunVodVideoInfo = (id) => {
  let data = {
    id
  };
  return getData('/AlibabaCloud/GetAliyunVodVideoInfo', data);
}

export const getAliyunVodVideoInfoByCA = (courseActivationId) => {
  let data = {
    courseActivationId
  };
  return getData('/AlibabaCloud/GetAliyunVodVideoInfoByCA', data);
}

export const getAliyunVodVideoInfoByVideoId = (videoId) => {
  let data = {
    videoId
  };
  return getData('/AlibabaCloud/GetAliyunVodVideoInfoByVideoId', data);
}

export const getStsCredentials=(regionId, videoId)=>{
  let url="/AlibabaCloud/GetStsCredentials";
  let result = getData(url, {regionId: regionId, videoId: videoId});
  return result;    
}

export const cleanupVideosByTerm = (termId, removeYearCourse) => {
  let data = {
    termId: termId,
    removeYearCourse: removeYearCourse
  };
  let url = "/AlibabaCloud/CleanupVideosByTerm";
  let result = getData(url, data);
  return result;
}



// WEBPACK FOOTER //
// ./src/service/alibabaCloud.service.js